import React, { useEffect, useState } from "react";
import { string, object, func } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Facebook from "../../atoms/icons/social-share/facebook";
import Twitter from "../../atoms/icons/social-share/twitter";
import Telegram from "../../atoms/icons/social-share/telegram";
import Messanger from "../../atoms/icons/social-share/messanger";
import Whatsapp from "../../atoms/icons/social-share/whatsapp";
import Comment from "../../atoms/icons/social-share/comment";

import translate from "../../translate";
import { isMobileWeb } from "../../utils/utils";
import { setToogleCommentWidget } from "../../helper/actions";

import "./social-share-links.m.css";

const SocialShareLinks = ({
  setToogleCommentWidget,
  showCommentWidget,
  whatsappUrl,
  fbUrl,
  twitterUrl,
  storyId,
  title,
  url,
  publisherUrl,
  publisher,
}) => {
  const [mWeb, setmWeb] = useState("");

  const showComment = showCommentWidget[storyId] || false;
  let timerId = null;

  useEffect(() => {
    setmWeb(isMobileWeb());
    return () => clearInterval(timerId);
  }, []);

  const fullUrl = `${publisherUrl}/${url}`;

  const appendUtms = (socialUrl, media) => {
    media = `${media}_${mWeb}`;
    const time = new Date().getTime();
    const finalUrl = `${socialUrl}${encodeURIComponent(
      `?utm_source=${media}&utm_medium=Social&utm_campaign=socialsharebuttons&utm_content=${storyId}_${time}`
    )}`;

    return finalUrl;
  };

  const handleCommentsBtn = () => {
    if (publisher.name === "fit") {
      if (!document.getElementById("metype-1") && !document.getElementById("metype-2")) {
        const script1 = document.createElement("script"),
          script2 = document.createElement("script");

        script1.defer = true;
        script1.id = "metype-1";
        script1.innerHTML = ` window.talktype = window.talktype || function(f) {
                              if (talktype.loaded)
                                f();
                              else
                                (talktype.q = talktype.q || []).push(arguments);
                              }`;

        script2.src = "https://www.metype.com/quintype-metype/assets/metype.js";
        script2.defer = true;
        script2.id = "metype-2";
        document.head.append(script1, script2);
      }

      setToogleCommentWidget(!showComment, storyId);

      const metypeContainer = document.getElementById(`metype-comment-widget-${storyId}`);
      if (metypeContainer) {
        if (metypeContainer.children.length < 1) {
          metypeContainer.setAttribute("data-metype-page-url", window.location.href);
          metypeContainer.setAttribute("data-metype-window-height", window.innerHeight);
          metypeContainer.setAttribute("data-metype-screen-width", window.screen.width);
          talktype(function () {
            talktype.commentWidgetIframe(metypeContainer);
          });
        }
      }

      if (!showComment) {
        timerId = setTimeout(() => {
          document
            .getElementById(`metype-comment-widget-${storyId}`)
            .scrollIntoView({ behavior: "smooth", block: "center" });
        }, 0);
      }
    }
  };

  return (
    <ul styleName="social-share-links" className="social-share-links">
      <li className="facebook-share-icon">
        <a data-social-media-type="facebook" href={appendUtms(fbUrl, `Facebook`)} target="_blank" rel="nofollow">
          <Facebook text={translate(publisher.name, "share")} />
        </a>
      </li>
      <li className="twitter-share-icon">
        <a data-social-media-type="twitter" href={twitterUrl} target="_blank" rel="nofollow">
          <Twitter text={translate(publisher.name, "share")} />
        </a>
      </li>
      <li className="whatsapp-share-icon">
        <a data-social-media-type="whatsapp" href={appendUtms(whatsappUrl, `WhatsApp`)} target="_blank" rel="nofollow">
          <Whatsapp text={translate(publisher.name, "share")} />
        </a>
      </li>
      <li className="telegram-share-icon">
        <a
          href={`https://telegram.me/share/url?url=${appendUtms(fullUrl, "Telegram")}
          &text=${encodeURIComponent(title)}`}
          target="_blank"
          rel="nofollow"
        >
          <Telegram text={translate(publisher.name, "share")} />
        </a>
      </li>
      <li styleName="messanger-hide" className="messanger-share-icon messanger-hide">
        <a
          href={appendUtms(
            `http://www.facebook.com/dialog/send?link=${encodeURIComponent(
              fullUrl
            )}&app_id=907794602598966&redirect_uri=https://www.thequint.com/`,
            `Messenger`
          )}
          target="_blank"
          rel="nofollow"
        >
          <Messanger text={translate(publisher.name, "share")} />
        </a>
      </li>
      <li className="comment-share-icon" onClick={handleCommentsBtn}>
        <Comment
          text={translate(publisher.name, "comments")}
          className={publisher.name === "quint-hindi" ? "" : "comment-wrapper"}
        />
      </li>
    </ul>
  );
};

SocialShareLinks.propTypes = {
  whatsappUrl: string,
  fbUrl: string,
  twitterUrl: string,
  title: string,
  url: string,
  storyId: string,
  publisherUrl: string,
  publisher: object,
  showCommentWidget: object,
  setToogleCommentWidget: func,
};

const mapStateToProps = (state) => ({
  showCommentWidget: get(state, ["storyReducer", "showCommentWidget"], {}),
  publisher: get(state, ["qt", "config", "publisher-attributes"], {}),
});

const mapDispatchToProps = (dispatch) => ({
  setToogleCommentWidget: (flag, storyId) => dispatch(setToogleCommentWidget(flag, storyId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SocialShareLinks);
